import {distinctUntilChanged, fromEvent, map, merge, Observable, scan} from "rxjs";
import {singleton} from "tsyringe";
import {AbstractLitElement} from "../components/abstract-lit.element";

type TrackingInfo = {
    mouseOver: Element | null,
    ctrlPressed: false
}

@singleton()
export class TimelineAddIssueTrackingService {

    private _state: TrackingInfo = {
        mouseOver: null,
        ctrlPressed: false
    };

    public register(element: AbstractLitElement): Observable<TrackingInfo> {

        return merge(
            fromEvent<PointerEvent>(element, `mousemove`).pipe(
                map(evt => (evt.target as Element).closest(`.cell`)),
                distinctUntilChanged((previous, current) => previous === current),
                map(element => ({mouseOver: element}))
            ),
            fromEvent<PointerEvent>(document, `keydown`).pipe(
                map(evt => ({ctrlPressed: evt.ctrlKey})),
            ),
            fromEvent<PointerEvent>(document, `keyup`).pipe(
                map(() => ({ctrlPressed: false})),
            )
        ).pipe(
            scan(
                (state, changes) => {
                    return {...state, ...changes} as TrackingInfo;
                },
                this._state
            ),
            distinctUntilChanged(
                (previous, current) => previous.mouseOver === current.mouseOver && previous.ctrlPressed === current.ctrlPressed
            ),
        );
    }
}